module.exports = {

    API_SEARCH_LIST_FROM_ID: "/public/lista-regalo/search-id",
    API_SEARCH_LIST_FROM_NAME: "/public/lista-regalo/search-name",
    API_GET_PRODUCT_LIST: "/public/lista-regalo/search-products",
    API_GET_ADDRESS_FROM_LIST: "/lista-regalo/search-address",



}